module.exports = __webpack_public_path__ + "static/img/home.db102310.png";